import TableView from '@nile/banyan/src/Pages/ServiceCatalog/TableView';
import {
  getAccessor,
  getType,
  isEditable,
  isFilterable,
  isSortable,
  isBold
} from '@nile/client_management/src/Pebbles/InvoiceDetails';
import {
  B1,
  ContentDeciderContainer,
  getTranslatedText,
  Loader,
  TableLoading,
  BackgroundIcon,
  AppContext,
  getDownloadURL,
  ALL_MODULES,
  HourGlassLoader,
  TableContainer,
  Tag,
  CardPage,
  HeaderTag,
  B3T2,
  Icon,
  toast,
  ConfirmationModal,
  DeleteModal,
  AccessControl,
  INVOICE_STATUS,
  getParsedCrudData,
  ListInfoBanner,
  BrandingLogo,
  TEXT_LENGTH,
  isAuthorised,
  NO_ITEM_TAX_CLIENTS,
  formatDataForSelectDropdown,
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator,
  SkeletonTableLoading,
  CustomModal,
  getStateCode,
  DateTimeFormatter,
  QUOTE_STATUS,
  StateCountryLabel,
  TAX_ROUND_OFF,
  CurrencyText,
  useCheckFeatureGating,
  getEntityAttributes,
  useIsAuthorisedHook,
  DisabledTag
} from '@nile/components';
import { DateTimeCell } from '@nile/mangifera/src/Components/Ticket';
import { DataGetter } from '@nile/components/src/Containers/Worklog/utils';
import { renderToString } from 'react-dom/server';
import PaidStamp from '@nile/components/src/Svg/AnimatedSvg/PaidStamp.svg';
import ActiveIntegrationIcon from '@nile/client_management/src/Components/ActiveInvoiceBillingIntegrationIcon';
import { getTabId } from '@nile/mangifera/src/Pebbles/TabManager';
import InvoiceActionButtons from '@nile/client_management/src/Pages/Protected/ClientNavigation/InvoiceActionCell';
import {
  Button,
  Popover,
  ActionList,
  TextField,
  DateTimePicker,
  Dropdown,
  Sheet,
  Banner,
  Heading,
  TextStyle
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { Page } from '@shopify/polaris';
import {
  AccountClient,
  GET_CLIENT_INVOICE,
  UPDATE_INVOICE,
  DELETE_INVOICE,
  GET_INTEGRATIONS_BY_IDS,
  GET_SEND_AND_INTEGRATION_STATUS,
  PUSH_INVOICE,
  SEND_INVOICE,
  GET_ALL_TAX,
  GET_CLIENT_INVOICE_SETTINGS,
  GET_CLIENT_INVOICE_SETTING,
  MockTicketClient,
  GET_INVOICE_TEMPLATE,
  useCachedQuery,
  GET_QUOTE,
  useLazyQuery as customUseLazyQuery,
  GET_ENTITY_PROPERTIES,
  GET_QUOTE_CONFIG,
  FETCH_INVOICE_CONFIGURATION
} from '@nile/graphql';
import DOMPurify from 'dompurify';
import envConfig from '@nile/home/src/Config/env';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import { isEmpty, includes, isEqual, omit, cloneDeep, debounce } from 'lodash';
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback
} from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { useMutation, useQuery, useLazyQuery } from '@apollo/client';
import { HIDE_PAYMENT_BUTTON_FOR_STATUS } from '@nile/client_management/src/Constants/invoice';
import InvoiceErrors from '@nile/client_management/src/Components/InvoiceErrors';
import { getTotalValue } from '@nile/banyan/src/Pebbles/tax';
import { SizeMe, withSize } from 'react-sizeme';
import dayjs from 'dayjs';
import { defaultLayoutConfigObj } from '@nile/banyan/src/Constants/defaultLayoutConfig';
import TaxCell from '@nile/client_management/src/Pages/Invoice/TaxCell';
import MultilineCell from '@nile/client_management/src/Pages/Invoice/MultilineCell';
import ServiceItemCell from '@nile/client_management/src/Pages/Invoice/ServiceItemCell';
import TextEditCell from '@nile/client_management/src/Pages/Invoice/TextEditCell';
import CurrencyCell from '@nile/client_management/src/Pages/Invoice/CurrencyCell';
import DeleteCell from '@nile/client_management/src/Pages/Invoice/DeleteCell';
import InvoiceStatusCell from '@nile/client_management/src/Pages/Protected/ClientNavigation/InvoiceStatusCell';
import { dompurifier } from '@nile/components/src/Utils/helpers';
import { sortItems } from '@nile/client_management/src/Pages/Invoice/Utils';
import { GET_FIELDS } from '@nile/banyan/src/Graphql/Mutations/ticket';
// import html2canvas from 'html2canvas';
// import { jsPDF } from 'jspdf';

let pdfTimer = null;

const LoaderWrapper = styled.div`
  display: inline-grid;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 200px;
`;

const Comments = styled(DataGetter)`
  border: 1px solid #ececec;
  background: none;
  border-radius: 10px;
  border: none !important;
  padding: 0px 15px;
  min-height: 38px;
  display: flex;
  flex-grow: 1;
  textarea {
    font-weight: normal !important;
  }
  .Superops-TextField__Input:disabled,
  .Superops-TextField--variantOutline > input:disabled,
  .Superops-TextField--variantOutline {
    background-color: transparent !important;
    cursor: auto !important;
  }
`;

const Footer = styled.div`
  padding: 20px;
  border-top: 1px solid #ececec;
  img {
    max-width: 100%;
  }
`;

const Wrapper = styled(CardPage)`
  -webkit-print-color-adjust: exact;
  page-break-inside: avoid;
  break-inside: avoid;
  .table,
  table {
    display: table;
    page-break-inside: auto;
  }
  th {
    break-inside: avoid;
  }
  tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }
  thead {
    // display: table-header-group;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  tbody .unFreezeContent {
    display: inline;
  }
  .Polaris-Page {
    max-width: ${(props) =>
      props.isChatVisible ? 'calc(100% - 520px) !important' : '990px'};
    width: ${(props) => (props.isChatVisible ? '100%' : '990px')};
  }
  .Polaris-Page-Header {
    padding: 20px !important;
  }
  .Polaris-Page {
    display: flex;
    flex-direction: column;
  }
  .Polaris-Page__Content {
    flex: 1;
  }
  .Superops-TextField__ActionableSuffix {
    background: ${(props) =>
      props.clicked ? '#fffae4' : 'rgba(0, 0, 0, 0.05)'};
    border-radius: 10px 10px 0 0;
    transition: background 200ms linear;
  }
  .colHeader {
    padding-left: 8px;
  }
  .Superops-TextField__Input {
    border-bottom: 1px solid #ececec;
  }
  .Superops-Connected {
    padding-top: 0 !important;
  }
  .Superops-TextField__Input {
    min-height: 38px;
  }
  .Superops-TextField__Input {
    padding-left: 4px;
  }
  .Superops-Banner__Position {
    width: 100%;
  }
  .red {
    color: red;
  }
  .sk-table-container {
    height: 400px !important;
  }
  .branding-logo {
    margin-bottom: 10px !important;
  }
  .msp-name {
    font-size: 18px !important;
    // margin-left: 10px;
    font-weight: 600;
  }
  .invoice-title {
    font-weight: 600;
    font-size: 20px !important;
    line-height: 32px;
  }
`;

const Header = styled.div`
  display: flex;
  .Polaris-Link {
    color: #000 !important;
  }
`;

const Info = styled.div`
  line-height: 30px;
`;

const ClientInfo = styled.div`
  margin-bottom: 10px;
  padding: 20px;
  padding-top: 0;
  .site-info {
    line-height: 21px;
  }
  [data-id='entityAttribute.client.name'],
  [data-id='attribute.msp.name'],
  [data-id='entityAttribute.site.name'] {
    font-size: 20px;
    font-weight: 600;
  }
`;

const DateSection = styled.div`
  .react-datepicker-wrapper,
  .react-datepicker__input-container > input {
    width: 92px;
  }
`;

const Total = styled.div`
  font-size: 20px;
  margin-left: auto;
  background-color: #f1f6ff;
  border-radius: 10px;
  width: 400px;
  div {
    display: flex;
    flex-basis: 50%;
  }
`;

const Row = styled.div`
  line-height: 35px;
  font-weight: 500;
`;

const Cell = styled.div`
  flex-grow: 1;
  flex-basis: 25%;
`;

const Cost = styled.div`
  width: 700px;
  font-size: 16px;
`;

const TableContainerWrapper = styled(TableContainer)`
  .table {
    font-size: 12px;
  }
  .colHeader {
    font-size: 10px;
  }
`;

const SignatureDisplayContainer = styled.div`
  font-size: 60px;
  font-weight: 700;
  padding: 9px 15px;
  line-height: 40px;
  min-height: 100px;
  line-break: anywhere;

  font-family: 'Qwitcher Grypen', cursive;

  &.empty {
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
      'Helvetica Neue', sans-serif;
    color: #a3a3a3;
  }
`;

const invoiceNode = React.createRef();

// const invoiceWorker = new Worker('./Workers/invoiceEditCalculations.js');

const dataQueue = [];

function InvoiceDetailsPdf(props) {
  const { intl, match, flags, dataAvailable } = props;
  const contractsNew = useCheckFeatureGating('CONTRACT_V3')?.enabled;

  const appContext = useContext(AppContext);
  const { user } = appContext;
  const [invoiceSettings, setInvoiceSettings] = useState(null);
  const isTaxForIndividualItemsNotAllowed = false;

  const isQuoteCustomFieldsAuthorised = useIsAuthorisedHook(
    'billingCustomFields.view'
  );
  const isClientCustomFieldsAuthorised = useIsAuthorisedHook(
    'clientCustomFields.view'
  );

  const company = props.company || appContext.company;
  // const [currentState, setCurrentState] = useState(
  //   STATE_LIST.find(
  //     (st) =>
  //       st.isoCode === company?.stateCode &&
  //       st.countryCode === company?.countryCode
  //   )?.name
  // );
  const ROUND_OFF_LIMIT = 2;
  const currencyCode = company?.currency || 'USD';
  const countryCode = company?.countryCode || 'US';
  const { id } = match.params;
  const quoteId = dataAvailable
    ? null
    : props.quoteId || (match?.params?.viewtype === 'quoteList' ? id : null);
  const accountClient = props.accountClient || AccountClient;
  const loading = false;
  const [columnGroup, setColumnGroup] = useState([
    { Header: 'Name', columns: [] }
  ]);
  const [sheetActive, setSheetActive] = useState(false);
  const [data, setData] = useState(props.data || {});
  const [manipulatedData, setManipulatedData] = useState({});
  const dataRef = useRef(0);
  dataRef.current = data;

  const [listLoading, setListLoading] = useState(dataAvailable ? false : true);

  const [retry, setretry] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [loaderShow, setloaderShow] = useState(true);
  const [useAnimatedSVG, setUseAnimatedSVG] = useState(false);
  const [generateInvoiceLoaderShow, setgenerateInvoiceLoaderShow] = useState(
    false
  );
  const [listInfo, setListInfo] = useState({});
  const [editMode, setEditMode] = useState(false);
  const editModeRef = React.useRef(2);
  editModeRef.current = editMode;
  const [actionLoading, setActionLoading] = useState(false);
  const [invoiceNote, setInvoiceNote] = useState('');
  const [integrationAppAndInvoiceId, setIntegrationAppAndInvoiceId] = useState(
    null
  );
  const [allTaxData, setAllTaxData] = useState(null);
  const [inactiveFields, setInactiveFields] = useState([]);
  const [
    getAllTax,
    { loading: taxLoading, error: taxError, data: taxData }
  ] = useLazyQuery(GET_ALL_TAX, {
    client: accountClient,
    onCompleted(response) {
      setAllTaxData(response?.getAllTax);
    }
  });

  const {
    loading: entitiesLoading,
    error: entitiesError,
    data: allEntities
  } = useQuery(GET_ENTITY_PROPERTIES, {
    client: accountClient
  });

  const notClient = appContext.accountType !== 'CLIENT';

  const getAccessor = (col) => {
    switch (col.name) {
      case 'worklogDate':
        return 'billedDate';
      case 'details':
        return 'details';
      case 'itemDetails':
        return contractsNew ? 'serviceCatalogItem.name' : 'serviceItem.name';
      default:
        return col.name;
    }
  };

  useEffect(() => {
    if (quoteId) fetchViewData();
    setEditMode(false);
  }, [quoteId]);

  // const calculateData = (modifiedData) => {
  //   // setIsCurrentProcessRunning(true);
  //   currentProcessRunning = true;
  //   if (modifiedData.isQueue) {
  //     // console.log('calling from queue');
  //   }

  //   invoiceWorker.postMessage({ msg: 'calculateData', data: modifiedData });
  // };
  const getWidth = (col) => {
    switch (col.name) {
      case 'worklogDate':
        return 110;
      case 'itemDetails':
        return 110;
      case 'details':
        return 150;
      case 'quantity':
        return 100;
      case 'unitPrice':
        return 100;
      case 'discount':
        return 100;
      default:
        return 100;
    }
  };
  // useEffect(() => {
  //   invoiceWorker.onmessage = (event) => {
  //     console.log('setting modified data');
  //     setData(event.data);
  //     // setIsCurrentProcessRunning(false);
  //     currentProcessRunning = false;
  //     if (dataQueue.length) {
  //       const dataToCalculate = dataQueue.shift();
  //       const {
  //         key,
  //         value,
  //         field,
  //         meta,
  //         properties,
  //         itemProperties
  //       } = dataToCalculate;
  //       const modifiedData = cloneDeep(event.data);
  //       calculateData({
  //         modifiedData,
  //         key,
  //         value,
  //         field,
  //         meta,
  //         properties,
  //         itemProperties,
  //         isQueue: true
  //       });
  //     }
  //   };
  // }, [invoiceWorker]);

  const handleDownload = async () => {
    // const pdf = new jsPDF('portrait', 'pt', 'a4');
    // const pdfData = await html2canvas(document.querySelector('#invoice-pdf'));
    // const img = pdfData.toDataURL('image/png');
    // const imgProperties = pdf.getImageProperties(img);
    // const pdfWidth = pdf.internal.pageSize.getWidth();
    // const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
    // pdf.addImage(img, 'PNG', 0, 0, pdfWidth, pdfHeight);
    // pdf.save('shipping_label.pdf');
    // const pdfData = await html2canvas(document.querySelector('#invoice-pdf'));
    // const imgData = pdfData.toDataURL('image/png');
    // const imgWidth = 210;
    // const pageHeight = 295;
    // const imgHeight = (pdfData.height * imgWidth) / pdfData.width;
    // let heightLeft = imgHeight;
    // const doc = new jsPDF('p', 'mm');
    // let position = 0;
    // doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    // heightLeft -= pageHeight;
    // while (heightLeft >= 0) {
    //   position = heightLeft - imgHeight;
    //   doc.addPage();
    //   doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    //   heightLeft -= pageHeight;
    // }
    // doc.save('file.pdf');
  };

  const setColumnData = (edit) => {
    const cols = [
      {
        name: 'itemDetails',
        label: getTranslatedText(intl, 'invoice.details.list.itemDetails')
      },
      {
        name: 'details',
        label: getTranslatedText(intl, 'invoice.details.list.details')
      },
      {
        name: 'quantity',
        label: getTranslatedText(intl, 'invoice.details.list.quantityOrHours')
      },
      {
        name: 'unitPrice',
        label: getTranslatedText(intl, 'invoice.details.list.unitPrice')
      },
      {
        name: 'discountRate',
        label: getTranslatedText(intl, 'invoice.details.list.discount')
      },
      {
        name: 'tax',
        label: getTranslatedText(intl, 'invoice.details.list.tax')
      },
      {
        name: 'amount',
        label: getTranslatedText(intl, 'invoice.details.list.total')
      }
    ];

    const columns = cols.map((col, idx) => {
      return {
        Header: col.label,
        accessor: getAccessor(col),
        // minWidth: col.name === 'subject' ? 400 : 50,
        width: getWidth(col),
        type: getType(col),
        id: col.name,
        disableResizing: false,
        className: 'sticky',
        disableSortBy: true,
        editable: isEditable(col),
        disableFilters: !isFilterable(col),
        actions: {
          onChange: () => {}
          // onChange: debounce(modifyData, 10)
        },
        field: col,
        allData: data || {},
        isBold: isBold(col),
        alignRight: col.name === 'amount',
        suffix: col.name === 'discountRate' ? '%' : '',
        editMode: editModeRef.current,
        clientId: data?.client?.accountId,
        currencyCode: currencyCode,
        countryCode: countryCode
      };
    });
    setColumnGroup([{ Header: 'Name', columns }]);
  };

  const [
    getClientInvoiceSettings,
    {
      loading: clientInvoiceSettingsLoading,
      data: clientInvoiceSettings,
      error: clientInvoiceSettingsError
    }
  ] = customUseLazyQuery(FETCH_INVOICE_CONFIGURATION, {
    client: accountClient,
    fetchPolicy: 'cache-and-network',
    onCompleted(response) {
      setInvoiceSettings({
        ...response?.fetchInvoiceConfiguration,
        quoteTemplate: {
          ...response?.fetchInvoiceConfiguration?.quoteTemplate,
          layoutConfiguration: {
            ...defaultLayoutConfigObj,
            ...response?.fetchInvoiceConfiguration?.quoteTemplate
              ?.layoutConfiguration
          }
        }
      });
    }
  });

  function generateFieldData({ entity, field: fieldData, isInactive }) {
    // let isEditAuthorised = false;

    const attributes = getEntityAttributes(allEntities, entity);

    const field = attributes?.find((f) => f.name === fieldData?.fieldName);

    if (!field) {
      return null;
    }

    switch (field.name) {
      case 'displayId':
        return (
          <div className="flex center">
            <span>{getTranslatedText(intl, 'quote.details.heading')}</span>
            <span className="ml8">
              <B1>{`#${data.displayId}`}</B1>
            </span>
          </div>
        );
      case 'quoteDate':
        return (
          <div className="flex center lh-30">
            <FormattedMessage id="quote.details.quoteDate" /> :{' '}
            <span className="ml8">
              <TextStyle weight="SemiBold">
                <DateTimeFormatter
                  type="date"
                  // date={dayjs().format('YYYY-MM-DD')}
                  date={data.quoteDate}
                />
              </TextStyle>
              {/* {`${data.invoiceDate}`} */}
            </span>
          </div>
        );
      case 'expiryDate':
        return (
          <>
            <div className="flex center lh-30">
              <FormattedMessage id="quote.details.expiryDate" /> :{' '}
              <span className="ml8">
                <TextStyle weight="SemiBold">
                  {data.expiryDate ? (
                    <DateTimeFormatter
                      type="date"
                      // date={dayjs().format('YYYY-MM-DD')}
                      date={data.expiryDate}
                    />
                  ) : (
                    'NA'
                  )}
                </TextStyle>
              </span>
            </div>
          </>
        );
      default:
        const displayValue =
          entity === 'Client'
            ? data?.client?.customFields?.[field?.name] || ''
            : data?.customFields?.[field?.name] || '';

        // if (isInactive && !displayValue) {
        //   return null;
        // }

        // if (field?.entity === 'Quote') {
        //   isEditAuthorised = isQuoteCustomFieldsAuthorised;
        // }
        // if (field?.entity === 'Client') {
        //   isEditAuthorised = isClientCustomFieldsAuthorised;
        // }

        return (
          <div className="flex center lh-30">
            <FormattedMessage id={field?.label || `attribute.${field?.name}`} />
            :{' '}
            <span className="ml8">
              {displayValue || (
                <DisabledTag>
                  <FormattedMessage id="app.noData.message" />
                </DisabledTag>
              )}
            </span>
          </div>
        );
    }
  }

  useEffect(() => {
    setColumnData();
  }, [editMode]);

  const checkRowHighlight = (row) => {
    return false;
  };

  /**
   * Method to get Service items.
   * Call this method to fetch/refetch the data on mounting/sorting/filtering
   * @param {object} personalization
   * @param {object} pageOptions
   */

  const fetchViewData = (personalization, pageOptions) => {
    setListLoading(true);
    setloaderShow(true);
    setretry(false);
    setgenerateInvoiceLoaderShow(false);
    let apiTimeout = setTimeout(getQuoteAPI, 3000);
    let time = 10;
    let clientCustomFields = [];

    async function getQuoteAPI() {
      await accountClient
        .query({
          query: GET_QUOTE_CONFIG
        })
        .then((res) => {
          if (res?.data?.getQuoteConfiguration?.preferences?.fieldSettings) {
            clientCustomFields = res?.data?.getQuoteConfiguration?.preferences?.fieldSettings?.filter(
              (field) => field?.entity === 'Client'
            );
            const customFieldsToGetDetails = res?.data?.getQuoteConfiguration?.preferences?.fieldSettings
              ?.filter((field) => field?.fieldCategory === 'CUSTOM')
              ?.filter((field) => {
                if (field?.entity === 'Quote') {
                  return isQuoteCustomFieldsAuthorised;
                }
                if (field?.entity === 'Client') {
                  return isClientCustomFieldsAuthorised;
                }
                return false;
              });
            if (customFieldsToGetDetails?.length) {
              accountClient
                .query({
                  query: GET_FIELDS,
                  variables: {
                    input: customFieldsToGetDetails?.map((field) => ({
                      entity:
                        field?.entity === 'Quote' ? 'Billing' : field?.entity,
                      columnName: field?.fieldName
                    }))
                  },
                  fetchPolicy: 'no-cache'
                })
                .then((res) => {
                  setInactiveFields(
                    res?.data?.getFields
                      ?.filter((field) => field?.status === 'INACTIVE')
                      ?.map((field) => field?.columnName)
                  );
                });
            }
          }
        });
      const response = await accountClient.query({
        query: GET_QUOTE,
        variables: {
          input: { quoteId: quoteId },
          isTaxSplitEnabled: true,
          clientCustomFields:
            clientCustomFields?.map((field) => field?.fieldName) || []
        },
        fetchPolicy: 'network-only'
      });
      if (response?.data?.getQuote?.operationStatus === 'PROGRESS') {
        setgenerateInvoiceLoaderShow(true);
        setloaderShow(false);
        if (time < 100) {
          apiTimeout = setTimeout(getQuoteAPI, 3000);
          time += 10;
        } else {
          setloaderShow(false);
          setretry(true);
          clearTimeout(apiTimeout);
        }
      } else {
        setloaderShow(false);
        setgenerateInvoiceLoaderShow(false);
        clearTimeout(apiTimeout);
        const cols = [
          {
            name: 'itemDetails',
            label: getTranslatedText(intl, 'invoice.details.list.itemDetails')
          },
          {
            name: 'details',
            label: getTranslatedText(intl, 'invoice.details.list.details')
          },
          {
            name: 'quantity',
            label: getTranslatedText(
              intl,
              'invoice.details.list.quantityOrHours'
            )
          },
          {
            name: 'unitPrice',
            label: getTranslatedText(intl, 'invoice.details.list.unitPrice')
          },
          {
            name: 'discountRate',
            label: getTranslatedText(intl, 'invoice.details.list.discount')
          },
          {
            name: 'tax',
            label: getTranslatedText(intl, 'invoice.details.list.tax')
          },
          {
            name: 'amount',
            label: getTranslatedText(intl, 'invoice.details.list.total')
          }
        ];

        const columns = cols.map((col, idx) => {
          return {
            Header: col.label,
            accessor: getAccessor(col),
            // minWidth: col.name === 'subject' ? 400 : 50,
            width: getWidth(col),
            type: getType(col),
            id: col.name,
            disableResizing: false,
            className: 'sticky',
            disableSortBy: true,
            editable: isEditable(col),
            disableFilters: !isFilterable(col),
            dataType: col?.name === 'worklogDate' ? 'date' : '',
            actions: {
              onChange: () => {}
              // onChange: debounce(modifyData, 10)
            },
            field: col,
            allData: response?.data?.getQuote || {},
            isBold: isBold(col),
            alignRight: col.name === 'amount',
            suffix: col.name === 'discountRate' ? '%' : '',
            editMode: editModeRef.current,
            clientId: response?.data?.getQuote?.client?.accountId,
            currencyCode: currencyCode,
            countryCode: countryCode
          };
        });
        setColumnGroup([{ Header: 'Name', columns }]);
        if (response?.data?.getQuote) {
          setData({
            ...response?.data?.getQuote,
            template: {
              content: response?.data?.getQuote?.footer || '',
              inlineImages: []
            }
          });
        }
        setIntegrationAppAndInvoiceId(
          response?.data?.getQuote?.integratedAppInvoiceId?.split('#')
        );
        setManipulatedData(response?.data?.getQuote);
        setInvoiceNote(response?.data?.getQuote?.notes || '');
        setListLoading(false);
        if (response?.data?.getQuote?.client?.accountId && quoteId) {
          getClientInvoiceSettings({
            variables: {
              input: {
                accountId: response?.data?.getQuote?.client?.accountId
              }
            }
          });
        }
        // if (response?.data?.getQuote?.statusEnum === 'DRAFT') {
        //   setEditMode(true);
        // }
        // Failure case. If required, alert the user.
      }
    }
  };

  useEffect(() => {
    if (quoteId) fetchViewData();
    getClientInvoiceSettings();
    // return function cleanup() {
    // if (invoiceWorker) {
    // invoiceWorker.terminate();
    // }
    // };
  }, []);

  if (clientInvoiceSettingsLoading || entitiesLoading) {
    return (
      <div className="full-height bg-white flex center jcenter">
        <Loader />
      </div>
    );
  }

  if (listLoading) {
    return (
      <LoaderWrapper>
        {loaderShow && (
          <div className="pt16 sops-display-block">
            <Loader />
          </div>
        )}
        {generateInvoiceLoaderShow && !retry && (
          <div className="pt16 sops-display-block">
            <HourGlassLoader
              heading={getTranslatedText(intl, 'invoice.create.loading')}
              imageURL={`${envConfig.imageRoot}svg/Hourglass.svg`}
              boxWidth="660px"
            />
          </div>
        )}

        {retry ? (
          <div className="pt16 margin-auto text-align-centr">
            <span className="pt16 mb16 sops-display-block">
              <FormattedMessage id="invoice.allInvoice.retry.description" />
            </span>

            <Button primary onClick={fetchViewData}>
              <FormattedMessage id="invoice.allInvoice.retry.again" />
            </Button>
          </div>
        ) : (
          ''
        )}
      </LoaderWrapper>
    );
  }
  if (isEmpty(data)) {
    return <div>loading...</div>;
  }
  const { client, site } = data;
  const defaultColumnCells = {
    Currency: CurrencyCell,
    Tax: TaxCell,
    Multiline: MultilineCell,
    ServiceItem: ServiceItemCell,
    TextEdit: TextEditCell,
    ItemDelete: DeleteCell,
    DateTime: DateTimeCell
  };
  const module = ALL_MODULES.quote;
  const details = {
    quoteId: quoteId
  };
  const url = getDownloadURL({ module, details, endPoint: 'direct_download' });
  const getSubTotal = (d) => {
    let sTotal = 0;
    const items = data.items || [];
    items.forEach((el) => {
      sTotal += Number(el.amount);
    });
    return sTotal;
  };
  const getTaxes = (d) => {
    let totalTax = 0;
    // change the taxAmount in tax group by calculating tax for each line item.
    if (data.taxes) {
      data.taxes.forEach((tax, idx) => {
        let taxAmount = 0;
        data.items.forEach((item) => {
          if (item.tax && item.tax.taxId === tax?.tax.taxId && item.taxable) {
            taxAmount += Number((item.amount * Number(tax.taxRate)) / 100);
          }
        });
        totalTax += taxAmount;
        totalTax = Number(parseFloat(totalTax).toFixed(ROUND_OFF_LIMIT));
      });
    }
    return totalTax;
  };
  // Calculate additional discount based on discountRate
  const getAdditionalDiscount = (sTotal, tRates) => {
    let additionalDiscount = 0;
    if (data.additionalDiscount) {
      additionalDiscount = data.additionalDiscount;
    } else if (data.additionalDiscountRate) {
      additionalDiscount =
        ((sTotal + tRates) * Number(data.additionalDiscountRate)) / 100;
    }
    additionalDiscount = Number(parseFloat(additionalDiscount).toFixed(2));
    return additionalDiscount;
  };
  const rows = [];
  const subTotal = getSubTotal(data);
  const taxRates = getTaxes(data);
  const additionalDiscount = getAdditionalDiscount(subTotal, taxRates);
  const grandTotal = subTotal + taxRates - additionalDiscount;

  if (data.discountAmount) {
    // Commenting this as discount is now applied to each line item. So subtotal need not include discount.
    // subTotal = Number(data.totalAmount) + Number(data.discountAmount);
    // rows.push({
    //   name: 'discount',
    //   prefix: '',
    //   rate: '',
    //   label: getTranslatedText(intl, 'invoice.details.list.discountRate'),
    //   value: data.discountAmount
    // });
  }

  if (data.taxes?.length) {
    if (editMode && isTaxForIndividualItemsNotAllowed) {
      const taxRate = getTotalValue(data.taxes?.[0]?.tax?.rates);
      rows.push({
        name: 'taxEdit',
        prefix: getTranslatedText(intl, 'invoice.details.list.taxCalculation'),
        rate: taxRate ? taxRate.toFixed(ROUND_OFF_LIMIT) : '',
        label: data.taxes?.[0]?.tax?.name,
        value: data.taxes?.[0]?.taxAmount,
        type: 'Tag'
      });
    } else {
      data.taxes.forEach((el, idx) => {
        // subTotal -= Number(el.taxAmount);
        rows.push({
          name: 'tax',
          prefix:
            idx === 0
              ? getTranslatedText(intl, 'invoice.details.list.taxCalculation')
              : '',
          rate: el.taxRate,
          label: true ? `${el.tax.name} - ${el?.rate?.name}` : el.tax.name,
          value: el.taxAmount,
          type: idx === 0 ? 'Tag' : ''
        });
      });
    }
  }
  if (
    editMode &&
    !integrationsError &&
    !integrationsLoading &&
    !isXeroIntegrated
  ) {
    if (
      data?.additionalDiscountRate !== null ||
      data?.additionalDiscount !== null
    ) {
      rows.push({
        name: 'additionalDiscountEdit',
        prefix: '',
        rate: '',
        label: 'Additional discount',
        // label: getTranslatedText(intl, 'invoice.details.list.additionalDiscount'),
        value: additionalDiscount,
        type: ''
      });
    } else {
      rows.push({
        name: 'addAdditionalDiscount',
        prefix: '',
        rate: '',
        label: 'Add additional discount',
        // label: getTranslatedText(
        //   intl,
        //   'invoice.details.list.addAdditionalDiscount'
        // ),
        value: '',
        type: ''
      });
    }
  } else if (data?.additionalDiscountRate || data?.additionalDiscount) {
    rows.push({
      name: 'additionalDiscount',
      prefix: '',
      rate: '',
      label: 'Additional discount',
      // label: getTranslatedText(intl, 'invoice.details.list.additionalDiscount'),
      value: additionalDiscount,
      type: ''
    });
  }
  if (data.discountAmount || data.taxAmount) {
    rows.unshift({
      name: 'subTotal',
      prefix: '',
      rate: '',
      label: getTranslatedText(intl, 'invoice.details.list.subTotal'),
      value: subTotal.toString()
    });
  }
  const getPrefix = (el) => {
    switch (el.type) {
      case 'Tag':
        return (
          <div className="flex jend mr10">
            <Tag>{el.prefix}</Tag>
          </div>
        );
      default:
        return <>{el.prefix}</>;
    }
  };
  const getLabel = (el) => {
    switch (el.name) {
      default:
        return <>{el.label}</>;
    }
  };

  const getValue = (el) => {
    switch (el.name) {
      case 'addAdditionalDiscount':
        return '';
      default:
        return <CurrencyText value={el.value} />;
    }
  };

  const getRate = (el) => {
    let displayVal = 'percent';
    switch (el.name) {
      case 'additionalDiscount':
        if (data.additionalDiscountRate) {
          return `${data.additionalDiscountRate}%`;
        }
        return '';
      default:
        return el.rate ? `${el.rate}%` : '';
    }
  };

  const renderSiteInfo = (info) => {
    if (info) {
      return <div className="site-info">{info}</div>;
    }
    return null;
  };

  const inlineNotesActivator = <SVGIcon name="Edit" />;

  const LayoutConfiguration = {
    ...defaultLayoutConfigObj,
    ...invoiceSettings?.quoteTemplate?.layoutConfiguration
  };

  const { mspInfo: mspConf, clientInfo: clientConf } = LayoutConfiguration;

  const showClientConf = Object.keys(clientConf).some((key) => clientConf[key]);

  return (
    <SizeMe monitorHeight monitorWidth>
      {({ size }) => {
        const isLargeScreen = size?.width > 1800;
        return (
          <Wrapper
            id="invoice-pdf"
            fullHeight
            contentPadding="20px 0"
            className={`full-height bg-white ${
              isLargeScreen ? 'flex center jcenter' : ''
            }`}
            clicked={clicked}
            ref={(node) => {
              if (!invoiceNode.current) {
                invoiceNode.current = node;
              }
            }}
            isChatVisible={isLargeScreen && data?.conversationIds?.length}
          >
            <div
              className={`full-height ${
                isLargeScreen ? 'flex center mw-100' : ''
              }`}
            >
              <Page
                title={
                  <Header className="center">
                    <Heading element="h1" weight="bold">
                      {data.title || `Estimate #${data.displayId}`}
                    </Heading>
                  </Header>
                }
              >
                <div
                  className="invoice-title mb20 content-padding"
                  element="h1"
                  weight="bold"
                >
                  {data?.description}
                </div>
                <ClientInfo className="grid g40 content-padding">
                  <div className="flex">
                    <div>
                      {/* <div>
                        <Logo className="logo" client={client} />
                      </div>
                      <div>
                        <HeaderTag title={client?.name} isNewLayout />
                      </div> */}
                      {mspConf?.hasOwnProperty('companylogo') ? (
                        mspConf?.companylogo && (
                          <BrandingLogo alignVertical hideName />
                        )
                      ) : (
                        <BrandingLogo alignVertical hideName />
                      )}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: dompurifier(
                            data?.senderAddress ||
                              manipulatedData?.senderAddress
                          )
                        }}
                      />
                    </div>
                    <div className="mlauto flex center self-start">
                      {includes(
                        [
                          QUOTE_STATUS.REJECTED.value,
                          QUOTE_STATUS.APPROVED.value
                        ],
                        data.statusEnum
                      ) && (
                        <div>
                          <BackgroundIcon
                            className="mr-10"
                            url={`url(${
                              envConfig.imageRoot
                            }svg/${data.statusEnum.toLowerCase()}.svg)`}
                            height="100px"
                            width="100px"
                          />
                        </div>
                      )}
                      <DateSection className="flex col aend">
                        {invoiceSettings?.quoteTemplate?.preferences?.fieldSettings?.map(
                          (field) => {
                            return (
                              <div key={`${field?.name}-${field?.entity}`}>
                                {generateFieldData({
                                  key: field?.fieldName,
                                  field: field,
                                  entity: field?.entity,
                                  isInactive: inactiveFields?.includes(
                                    field?.fieldName
                                  )
                                })}
                              </div>
                            );
                          }
                        )}
                        {/* <Info className="flex center">
                          <span>
                            {getTranslatedText(intl, 'quote.details.heading')}
                          </span>
                          <span className="ml8">
                            <B1>{`#${data.displayId}`}</B1>
                          </span>
                        </Info>
                        <Info className="flex center">
                          <FormattedMessage id="quote.details.quoteDate" /> :{' '}
                          <span className="ml8">
                            <TextStyle weight="SemiBold">
                              <DateTimeFormatter
                                type="date"
                                date={data.quoteDate}
                              />
                            </TextStyle>
                          </span>
                        </Info>
                        <Info className="flex center">
                          <FormattedMessage id="quote.details.expiryDate" /> :{' '}
                          {editMode ? (
                            <DateTimePicker
                              selected={
                                data.expiryDate &&
                                dayjs(data.expiryDate).toDate()
                              }
                              placeholderText={'YYYY-MM-DD'}
                              dateFormat={'yyyy-MM-dd'}
                              required
                              disabled={false}
                              popperPlacement="auto"
                            />
                          ) : (
                            <span className="ml8">
                              <TextStyle weight="SemiBold">
                                {data.expiryDate ? (
                                  <DateTimeFormatter
                                    type="date"
                                    date={data.expiryDate}
                                  />
                                ) : (
                                  'NA'
                                )}
                              </TextStyle>
                            </span>
                          )}
                        </Info> */}
                      </DateSection>
                    </div>
                  </div>
                  <div>
                    <B3T2 className="uppercase sub-header f-12">
                      <FormattedMessage id="invoice.details.billTo" />
                    </B3T2>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: dompurifier(
                          data?.billingAddress ||
                            manipulatedData?.billingAddress
                        )
                      }}
                    />
                  </div>
                </ClientInfo>
                {data.operationStatus !== 'PROGRESS' && (
                  <div className="mt40 content-padding">
                    <TableContainerWrapper>
                      <ContentDeciderContainer
                        isLoading={loading || !columnGroup[0]?.columns?.length}
                        hasContent
                        fullHeight
                        mainContent={
                          <TableView
                            context={{ records: [] }}
                            columns={columnGroup}
                            data={sortItems(data?.items) || []}
                            setData={setData}
                            rowCount={10000}
                            refreshTable={fetchViewData}
                            listInfo={listInfo}
                            pagination={false}
                            pages={0}
                            defaultColumnCells={defaultColumnCells}
                            recordCount={listInfo.totalCount}
                            activePage={listInfo.page || 0}
                            isLoading={
                              listLoading || data.operationStatus === 'PROGRESS'
                            }
                            noBulkSelect
                            fullHeight
                            dark
                            emptyState={{
                              nodataImage: `${envConfig.imageRoot}svg/not-found.svg`,
                              heading: getTranslatedText(
                                intl,
                                'invoice.list.noItems'
                              ),
                              description: ''
                            }}
                            alignStart
                            checkRowHighlight={checkRowHighlight}
                          />
                          // <div>Coming soon...</div>
                        }
                        loadingContent={<TableLoading rows={15} />}
                        notFoundURL={`${envConfig.imageRoot}svg/not-found.svg`}
                      />
                    </TableContainerWrapper>
                  </div>
                )}
                <div className="total-section mt-30 p20 pb-100 avoid-break flex g20">
                  {data?.memo && (
                    <div className="flex fg1">
                      <Comments>
                        <TextField
                          value={data?.memo}
                          multiline
                          disabled
                          autoComplete="off"
                        />
                      </Comments>
                    </div>
                  )}
                  <div className="mt10 mlauto mr8">
                    <Cost className="mt10 mlauto mr8">
                      {rows.length > 0
                        ? rows.map((el, idx) => {
                            return (
                              <Row
                                className={`flex center mlauto ${
                                  idx === 0 ? 'dash-separator' : ''
                                }`}
                              >
                                <Cell>{getPrefix(el)}</Cell>
                                <Cell>{getLabel(el)}</Cell>
                                <Cell>{getRate(el)}</Cell>
                                <Cell className="flex jend pr-20 bold">
                                  {getValue(el)}
                                </Cell>
                              </Row>
                            );
                          })
                        : ''}
                    </Cost>
                    <Total className="flex mr8 p20 mt-30 bold">
                      <div className="flex jend">
                        <FormattedMessage id="invoice.details.total" />
                      </div>
                      <div className="ml8 mlauto flex jend">
                        <CurrencyText value={grandTotal} />
                      </div>
                    </Total>
                  </div>
                </div>
                {data.statusEnum === QUOTE_STATUS.APPROVED.value ? (
                  <div className="flex col aend mt-20 pr40">
                    <FormattedMessage id="quote.details.approvedBy" />
                    <SignatureDisplayContainer>
                      {data?.approverName}
                    </SignatureDisplayContainer>
                  </div>
                ) : (
                  ''
                )}
                {data?.footer ? (
                  <Footer className="ml20 mr-20 avoid-break">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: dompurifier(data?.footer)
                      }}
                    ></div>
                  </Footer>
                ) : (
                  ''
                )}
              </Page>
            </div>
          </Wrapper>
        );
      }}
    </SizeMe>
  );
}

export default injectIntl(withRouter(withLDConsumer()(InvoiceDetailsPdf)));
